import {useQuery} from '@tanstack/react-query'
import {useAccessToken, useCommerceApi} from '@salesforce/commerce-sdk-react'
import CustomApi from './use-custom-api'

const useContentSlot = (slotId, selectedCountryCode) => {
    const {getTokenWhenReady} = useAccessToken()
    const customApi = new CustomApi()
    const api = useCommerceApi()
    const {proxy} = api.shopperExperience.clientConfig

    const fetchContentSlotById = async (slotId) => {
        const token = await getTokenWhenReady()
        const apiName = 'content-slot'
        const endpointPath = '/'
        const parameters = {
            c_slotId: slotId,
            c_selectedCountry: selectedCountryCode
        }
        const response = await customApi.get(token, apiName, endpointPath, parameters, proxy, true)

        return await response.text()
    }

    return useQuery({
        queryKey: ['use-content-slot', slotId, selectedCountryCode],
        queryFn: () => fetchContentSlotById(slotId),
        enabled: !!slotId,
        keepPreviousData: true,
        staleTime: 3 * 60 * 60 * 10000,
        cacheTime: 3 * 60 * 60 * 10000,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false
    })
}

export default useContentSlot
